import { useKeepDetailsUpdated } from './useKeepDetailsUpdated'

export const ResourceStreamSynchronizer = () => {
  useKeepDetailsUpdated('Customer')
  useKeepDetailsUpdated('Employee')
  return null
}
